// extracted by mini-css-extract-plugin
module.exports = {"header":"e_ep","gallery":"e_fp","label":"e_gp"};